import { render } from "./FieldTabs.vue?vue&type=template&id=f05b734c"
import script from "./FieldTabs.vue?vue&type=script&lang=js"
export * from "./FieldTabs.vue?vue&type=script&lang=js"
script.render = render

export default script